import React from 'react';
import {I18n} from 'react-redux-i18n';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import {toLower, toUpper} from 'lodash';
import {translateOer} from '../../../util';

import CollisionMit from './images/collisionmit-icon.svg';
import ForwardCol from './images/forwardcol-icon.svg';
import Headway from './images/headway-icon.svg';
import OOTN from './images/oot-icon.svg';
import HarshTurn from './images/harsh-turn-icon.svg';
import suddenStopIcon from './images/sudden-stop-icon.svg';
import onDemandIcon from './images/ondemand-icon.svg';
import suddenStartIcon from './images/sudden-start-icon.svg';
import Fatigue from './images/fatigue-icon.svg';
import CellphoneUsage from './images/cellphone-usage-icon.svg';
import DriverDistraction from './images/distracted-driving-icon.svg';
import DriverSmoking from './images/smoking-icon.svg';
import SeatBeltUsage from './images/no-seatbelt-icon.svg';
import CameraBlocked from './images/covered-camera-icon.svg';
import LaneDeparture from './images/lane-departure-icon.svg';
import ExcessiveSpeed from './images/excessive-speed-icon.svg';

export default class EventIcon extends React.PureComponent {
  static propTypes = {
    triggerType: PropTypes.string.isRequired,
    eventType: PropTypes.string,
    mediaId: PropTypes.string.isRequired,
    // SEE PNVI-5634
    handleClickOnDemand: PropTypes.func,
    handleClickEvent: PropTypes.func,
    locale: PropTypes.string,
    systemId: PropTypes.string,
  };

  static defaultProps = {
    locale: 'en',
    eventType: null,
    handleClickEvent: () => {},
    handleClickOnDemand: () => {},
    systemId: 'peoplenet'
  }

  render() {
    const {mediaId, eventType, systemId} = this.props;

    if (toLower(this.props.triggerType) === 'ondemand') {
      const title = I18n.t('filter.onDemand');
      return (
        <IconButton onClick={this.props.handleClickOnDemand}>
          <img title={title} alt={title} src={onDemandIcon} className="videoactions__suddenstop" id={`videoCardEventIcon-${mediaId}`} />
        </IconButton>
      );
    }

    switch (toUpper(eventType)) {
      case 'RULEJACKRABBITSTARTSID':
      case 'AGGRESSIVE_ACCELERATION':
      case 'SUDDEN_START':
        return (
          <IconButton onClick={this.props.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={suddenStartIcon} className="videoactions__suddenstart" id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'RULEHARSHBRAKINGID':
      case 'HARSH_BRAKING':
      case 'SUDDEN_STOP':
        return (
          <IconButton onClick={this.props.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={suddenStopIcon} className="videoactions__suddenstop" id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'MANUAL':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <Icon title={translateOer(eventType)} alt={translateOer(eventType)}className="videoactions__manual" id={`videoCardEventIcon-${mediaId}`}>touch_app</Icon>
          </IconButton>
        );
      case 'HEADWAY':
      case 'HEADWAY_MONITORING':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={Headway} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'RULEACCIDENTID':
      case 'MERITOR_ONGUARD_COLLISION_MITIGATION':
      case 'FRONTAL_COLLISION_PREDICTION':
      case 'COLLISION_MITIGATION':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={CollisionMit} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'STABILITY_CONTROL_7':
      case 'FORWARD_COLLISION_WARNING':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={ForwardCol} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'ROP_ENGINE_CONTROL':
      case 'RULEHARSHCORNERINGID':
      case 'HARD_CORNERING':
      case 'ROP_BRAKE_CONTROL':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={HarshTurn} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'YC_BRAKE_CONTROL':
      case 'YC_ENGINE_CONTROL':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <Icon title={translateOer(eventType)} alt={translateOer(eventType)} className="videoactions__oer" id={`videoCardEventIcon-${mediaId}`}>warning</Icon>
          </IconButton>
        );
      case 'DISTRESS':
      case 'PANIC':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <Icon title={translateOer(eventType)} alt={translateOer(eventType)} className="videoactions__panic" id={`videoCardEventIcon-${mediaId}`}>warning</Icon>
          </IconButton>
        );
      case 'OOT_SESSION_EXPIRED':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={OOTN} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'FATIGUE':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={Fatigue} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'CELLPHONE_USAGE':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={CellphoneUsage} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'EXCESSIVE_SPEEDING':
      case 'EXCESSIVE_SPEED':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={ExcessiveSpeed} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'DRIVER_DISTRACTION':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={DriverDistraction} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'DRIVER_SMOKING':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={DriverSmoking} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'SEAT_BELT_USAGE':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={SeatBeltUsage} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'CAMERA_BLOCKED':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={CameraBlocked} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      case 'LANE_DEPARTURE':
        return (
          <IconButton onClick={this.handleClickEvent}>
            <img title={translateOer(eventType)} alt={translateOer(eventType)} src={LaneDeparture} id={`videoCardEventIcon-${mediaId}`} />
          </IconButton>
        );
      default:
        return (
          <IconButton onClick={this.handleClickEvent}>
            <Icon title={translateOer(eventType)} alt={translateOer(eventType)} className="videoactions__oer" id={`videoCardEventIcon-${mediaId}`}>warning</Icon>
          </IconButton>
        );
    }
  }
}
